export default __webpack_public_path__ + "static/media/ContestAbout.4808883b.svg";